export default "__VITE_ASSET__BwwuhBfL__"